/*
 * @Author: LiuChuanQi
 * @Date: 2023-02-13 09:53:32
 * @LastEditTime: 2023-02-14 15:03:11
 * @LastEditors: LiuChuanQi
 * @Description: ase对称加解密
 * @FilePath: \speedtest-bigdata-v2\src\utils\hooks\aesDeciphering.js
 *
 */
import {ASEIV, ASEKEY} from '@/config/aes'
import CryptoJS from 'crypto-js'

/**
 * 对参数进行加密
 * @param {*} data
 * @returns
 */
export const aesEncrypt = (data) => {
    //秘钥（后端提供）由于对称解密使用的算法是 AES-128-CBC算法，数据采用 PKCS#7 填充 ， 因此这里的 key 需要为16位！
    let key = ASEKEY
    // 偏移量（后端提供）
    let iv = ASEIV
    const keyUTF8 = CryptoJS.enc.Utf8.parse(key)
    const offsetUTF8 = CryptoJS.enc.Utf8.parse(iv)
    const dataUTF8 = CryptoJS.enc.Utf8.parse(JSON.stringify(data))
    const bytes = CryptoJS.AES.encrypt(dataUTF8, keyUTF8, {
        iv: offsetUTF8,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    })
    //console.log(CryptoJS.enc.Base64.stringify(bytes.ciphertext));
    return CryptoJS.enc.Base64.stringify(bytes.ciphertext)
}

/**
 * 对数据进行解密
 * @param {String} data
 * @param {number} type 0:大数据的加密 1:测速网的加密
 * @return {JSON}
 * */
export const aesDecrypt = (data, type = 0) => {
    //秘钥（后端提供）由于对称解密使用的算法是 AES-128-CBC算法，数据采用 PKCS#7 填充 ， 因此这里的 key 需要为16位！
    let key = ASEKEY
    // 偏移量（后端提供）
    let iv = ASEIV
    const keyUTF8 = CryptoJS.enc.Utf8.parse(key)
    const offsetUTF8 = CryptoJS.enc.Utf8.parse(iv)
    const bytes = CryptoJS.AES.decrypt(data, keyUTF8, {
        iv: offsetUTF8,
        mode: type ? CryptoJS.mode.CBC : CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    })
    return JSON.parse(CryptoJS.enc.Utf8.stringify(bytes).toString())
}


